type TSubsection = {
  number: string
  content: string
  subsections?: TSubsection[]
}

type TPrivacyPolicy = {
  section: string
  subsections: TSubsection[]
}

const privacyPolicy: TPrivacyPolicy[] = [
  {
    section: 'Introduction',
    subsections: [
      {
        number: '1.1',
        content:
          'In order to provide the best experience for you, and in accordance with i.e Law of Republic Indonesia No. 27 Year 2022 Concerning Personal Data Protection and other applicable laws and regulations related with personal data protection, PT Populix Informasi Teknologi (hereinafter “Populix” or “we”) is hereby committed to protecting and respecting your privacy. For this reason, We determines this Privacy Policy to protect all personal data that is collected or transmitted through our site at Web Respondent by Populix (“Website”) or via e-mail that we send to you.',
      },
      {
        number: '',
        content:
          'By accessing or using Our Website, you acknowledge that each of your data is true and valid, and you have agreed to and accepted the practices set out in this Privacy Policy and agreed to comply with the Populix Terms and Conditions.',
      },
      {
        number: '',
        content:
          'Please read the following policies carefully to understand how and why we collect, store, share and use your personal data. We will also explain your rights when you share your personal data with us.',
      },
      {
        number: '',
        content:
          'If you disagree with the provisions of this Privacy Policy, please do not use our website or any other means that we have to send your personal information to us.',
      },
      {
        number: '1.2',
        content:
          'The term “Personal Data” means any information in our possession or control that relates directly or indirectly to an individual to the extent that the individual can be identified or are identifiable from that and other information in our possession, such as name, address, telephone number, Identification/Passport number, date of birth, photograph, email address, household information, etc. as well as other Personal Data as defined under the PDP Laws.',
      },
      {
        number: '',
        content:
          'The types of Personal Data collected depend on the purpose of collection. We may process your Personal Data by way of collecting, recording, holding, storing, using and/or disclosing it.',
      },
    ],
  },
  {
    section: 'Information we collect from you',
    subsections: [
      {
        number: '',
        content: 'We may collect and process data about you as follows:',
      },
      {
        number: '1',
        content: 'Name',
      },
      {
        number: '2',
        content: 'Address',
      },
      {
        number: '3',
        content: 'Date of birth',
      },
      {
        number: '4',
        content: 'Email',
      },
      {
        number: '5',
        content: 'Active phone number;',
      },
      {
        number: '6',
        content:
          'Demographic data (including but not limited to age, gender, ethnicity, income, education, marital status, and/or occupation);',
      },
      {
        number: '7',
        content: 'All information provided when you register to use any part of the Website;',
      },
      {
        number: '8',
        content: 'All information provided when you participate in a study;',
      },
      {
        number: '9',
        content: 'All information provided when you contact us by telephone or customer service;',
      },
      {
        number: '10',
        content: 'Records of your correspondence (if any) with us;',
      },
      {
        number: '11',
        content: 'Details of the transactions you make through the Website;',
      },
      {
        number: '12',
        content: 'Track of your activities on the Website, e.g., heatmap and screen record; and',
      },
      {
        number: '13',
        content:
          'Track of your visits to the Website, including, but not limited to, traffic data, location data, weblogs, and other communication data.',
      },
    ],
  },
  {
    section: 'Purpose',
    subsections: [
      {
        number: '',
        content:
          'The Personal Data as provided/furnished by you to us or collected by us from you or through such other sources as may be necessary for the fulfillment of the purposes at the time it was sought or collected, may be processed for the following purposes (collectively referred to as the “Purposes”):',
      },
      {
        number: '1',
        content:
          'to consider and/or process your transactions with us or your transactions or communications with third parties; ',
      },
      {
        number: '2',
        content:
          'to manage, operate, provide and/or administer your use of and/or access to our Website (including, but not limited to your preferences), as well as your relationship and your user account with us; ',
      },
      {
        number: '3',
        content:
          'to respond to, process, deal with or complete transactions and/or notify you of service issues and unusual account activities;',
      },
      {
        number: '4',
        content: 'to protect your personal information and rights as a user of our services;',
      },
      {
        number: '5',
        content: 'to identify and/or verify of personal data;',
      },
      {
        number: '6',
        content:
          'to maintain and provide feature updates that require access to your device to ensure the smooth running of our Website; ',
      },
      {
        number: '7',
        content:
          'to contact you via e-mail, letter, telephone, and others, to assist and/or respond to any questions or problem-solving processes related to our services;',
      },
      {
        number: '8',
        content:
          'to contact you or communicate with you through telephone calls, text messages and/or fax messages, e-mail and/or postal mail, or other means for the purpose of administering and/or managing your relationship with us or your use of our services, such as but not limited to communicating administrative information to you relating to our Website. You acknowledge and agree that such communication by us can be done by sending a letter, document, or notification to you, which may involve disclosing certain personal data about you to make such delivery and also listed on the outer cover of the envelope/postal package;',
      },
      {
        number: '9',
        content:
          'to track the use and activity of advertisements that are placed on the Website and understand our user acquisition;',
      },
      {
        number: '10',
        content:
          'to use the information obtained from you for research, analysis, product development, and testing purposes to improve services and security on the Website, as well as develop our new features and products;',
      },
      {
        number: '11',
        content:
          'to award points in a loyalty or rewards programme provided by loyalty service providers;',
      },
      {
        number: '12',
        content:
          'to enable audits, surveys, and analysis to, among other things, validate the size and composition of our target audience and understand their experience with us;',
      },
      {
        number: '13',
        content:
          'to produce statistics and research for internal reports and as required by law and/or archival requirements;',
      },
      {
        number: '14',
        content:
          'to prevent or investigate any fraud, unlawful activity, omission, or wrongdoing, whether related to your use of our Website or any other matter arising from your relationship with us and if there is any suspicion regarding the preceding or not;',
      },
      {
        number: '15',
        content: 'any other purposes that we will notify you of upon obtaining your consent.',
      },
      {
        number: '',
        content:
          'Due to the Purposes, we will/be able to collect, use, disclose or process your personal data depending on the situation and/or conditions we face, or other purposes that may not be listed above. However, we will notify you of other purposes other than those listed in Point 2 above when obtaining your consent unless the prevailing laws and regulations in the Republic of Indonesia permit data processing without your consent.',
      },
    ],
  },
  {
    section: 'Disclosure to Third Party',
    subsections: [
      {
        number: '',
        content:
          'We will not sell, rent, transfer or disclose any of your Personal Data to any third party without your consent. However, we may disclose your Personal Data to the following third parties, for one or more of the above Purposes:',
      },
      {
        number: '1',
        content:
          'parties who hire us to make the survey that You participate in. For this disclosure we are committed to only disclose unidentifiable personal data to the third party.',
      },
      {
        number: '2',
        content:
          'parties who assist us in running the Website, solely for the purpose of running the Website;',
      },
      {
        number: '3',
        content:
          'parties who assist us in providing and securing your rewards placement and withdrawal;',
      },
      {
        number: '4',
        content: 'successors in title to us;',
      },
      {
        number: '5',
        content: 'any party in relation to legal proceedings or prospective legal proceedings;',
      },
      {
        number: '6',
        content:
          'data centres and/or servers located within or outside Republic of Indonesia for data storage purposes or otherwise;',
      },
      {
        number: '7',
        content:
          'government agencies, law enforcement agencies, courts, tribunals, regulatory bodies, industry regulators, ministries, and/or statutory agencies or bodies, offices or municipality in any jurisdiction, if required or authorised to do so, to satisfy any applicable law, regulation, order or judgment of a court or tribunal or queries from the relevant authorities;',
      },
      {
        number: '8',
        content:
          'in the event of a potential, proposed or actual sale/disposal of any of our business or interest, merger, acquisition, consolidation, re-organisation, funding exercise or asset sale relating to us, or in the event of winding-up (“Transaction”), your Personal Data may be required to be disclosed or transferred to a third party as a result of or in connection with, the Transactions;',
      },
    ],
  },
  {
    section: 'Addresses and Cookies',
    subsections: [
      {
        number: '5.1',
        content: 'IP Address',
      },
      {
        number: '',
        content:
          'We may collect information about your computer, including but not limited to your IP address, operating system, and browser type. We do this for the benefit of our system administration and statistical analysis. For this purpose, we only collect statistical data connected to your browsing actions and patterns as a user; and will not identify any information regarding you individually.',
      },
      {
        number: '',
        content:
          'We may also obtain information about your general internet usage by using Cookies for the same reason.',
      },
      {
        number: '5.2',
        content: 'Cookies',
      },
      {
        number: '',
        content:
          "When you use the Application or visit our Website, certain information may be collected automatically by using Cookies. Cookies are small files that are stored on your computer's hardware. Cookies help us to improve the website and provide a better and more personalized service to each user.",
        subsections: [
          {
            number: '5.2.1',
            content: 'Cookies that we obtain and use are as follows:',
          },
          {
            number: '',
            content:
              '- Essential Cookies: These are necessary Cookies for the operation of our Website. These Cookies allow you to enter a secure area ("secure area") on our website, use a shopping cart, or use an e-billing service.',
          },
          {
            number: '',
            content:
              '- Analytics / Performance Cookies: These Cookies generally allow us to recognize and count the number of visitors and see how you are doing when visiting Our Website. This helps us improve the way Our Website works, by ensuring users find what they are looking for easily on the Website, and improve our product performance.​​',
          },
          {
            number: '',
            content:
              '- Functional Cookies: These Cookies are used to identify you when you return to our Website. These Cookies allow us to personalize our content for you, greet you by name and remember your preferences, for example, your choice of language or region.​',
          },
          {
            number: '',
            content:
              '- Targeting Cookies: These Cookies record your visits to our Website, the pages you have visited, and the links you have followed. We will use this information to make Our Website and its advertisements more relevant to your interests. We may also share this information with third parties for this purpose.​​',
          },
          {
            number: '',
            content:
              'Please be aware that third parties (including, for example, advertising networks and providers of external services such as web traffic analysis services) may also use Cookies, and We have no control over these Cookies.',
          },
        ],
      },
    ],
  },
  {
    section: 'Information Security',
    subsections: [
      {
        number: '6.1',
        content: 'Where we store your personal information​',
      },
      {
        number: '',
        content:
          "All information that you provide to us is stored encrypted on our servers. Every payment transaction on the website will be encrypted using Secure Socket Layer (SSL) technology. In order to maintain the safety of your privacy, the SSL system that we use is a verified system that can create an encrypted link between the user's browser session and the webserver of our website. SSL is the industry standard for secure web communications and is used to protect millions of online transactions.​",
      },
      {
        number: '6.2',
        content: 'Your responsibiliy​',
      },
      {
        number: '',
        content:
          'Please note that the transmission of information over the internet is not completely secure. Although we will do our best to protect your personal data, we cannot guarantee the security of your data sent to the website. Therefore, any information you provide through the website or other media is at your own risk. For example, when we give you (or if you have chosen) a password that allows you to access certain parts of the website, you are personally responsible for keeping that password confidential and not giving it to third parties. However, we guarantee that we will use appropriate security procedures and features to prevent unauthorized access when we receive your information, in accordance with the laws and regulations of the Republic of Indonesia.​',
      },
      {
        number: '',
        content:
          'From time to time, the website may contain links to and from the websites of a network of partners, advertisers, and affiliates. In the event that you follow a link to such a website, please note that the respective websites have their own privacy policies, and we are not responsible for those policies. Please check the policies of those websites before submitting your personal data.​',
      },
    ],
  },
  {
    section: 'Transfer Outside of Indonesia',
    subsections: [
      {
        number: '',
        content:
          'In the event that there is a transfer of personal data by us to a third party located outside the territory of the Republic of Indonesia we will:',
      },
      {
        number: 'a',
        content:
          'ensure that the country of residence of the recipient of personal data has a level of personal data protection that is equivalent or higher to that of personal data in Republic of Indonesia; or',
      },
      {
        number: 'b',
        content:
          'ensure that the country where the recipient of personal data is domiciled has adequate and binding personal data protection, or',
      },
      {
        number: 'c',
        content: 'obtain your consent first; and',
      },
      {
        number: 'd',
        content:
          'implement the provisions of laws and regulations regarding the transfer of personal data across national borders.',
      },
    ],
  },
  {
    section: 'Your rights',
    subsections: [
      {
        number: '',
        content:
          'Your rights Your rights to the personal data that you provide to us are as follows:',
      },
      {
        number: '1',
        content: 'The right to the confidentiality of personal data;',
      },
      {
        number: '2',
        content:
          'The right to submit a complaint in the context of resolving personal data disputes over the failure to protect the confidentiality of personal data by Populix to the Minister of Communication and Information Technology of the Republic of Indonesia;',
      },
      {
        number: '3',
        content:
          'The right to withdraw your consent related to the collection, use, and/or disclosure of your personal data that we have, including the right to stop using, access services, and/or close an account on our website with due observance of applicable laws and regulations in the Republic of Indonesia. Revocation of your consent could mean that we will not be able to continue providing the services to you, and we may have to terminate the relationship with you and/or the contract you entered into with us;',
      },
      {
        number: '4',
        content:
          'The right to access or the opportunity to change or update your personal data without disturbing our personal data management system, unless otherwise stipulated by the prevailing laws and regulations in the Republic of Indonesia; a. You can access and/or correct your personal data that we currently have or control through the Account Settings page on the Website. b. If you do not have an account on our website, you can request to access and/or correct your personal data that we currently have or control by sending us a written request. We will need sufficient information from you to confirm your identity and the nature of your request for us to handle your request. Therefore, please submit your request in writing by sending us an e-mail at support@populix.co.',
      },
      {
        number: '5',
        content:
          'The right to access or opportunity to obtain your historical personal data that has been submitted to us as long as it is still in accordance with the applicable regulations and laws in the Republic of Indonesia. We may charge you a reasonable fee to handle and process your request to access your personal data. If we choose to charge fees, we will provide you with an estimate of the fees to be charged in writing. Please note that we are not obliged to respond to or manage your access request unless you have agreed to pay the fees.',
      },
      {
        number: '6',
        content: 'The right to have your personal data deleted if any of the following occurs:',
        subsections: [
          {
            number: 'a',
            content: 'personal data is no longer needed for personal data processing’s purpose;',
          },
          {
            number: 'b',
            content: 'You have withdrawn your consent to process personal data;',
          },
          {
            number: 'c',
            content: 'upon your request; or',
          },
          {
            number: 'd',
            content: 'when the personal data was unlawfully obtained and/or processed.',
          },
        ],
      },
      {
        number: '7',
        content: 'The right to delete your Website account.',
      },
    ],
  },
  {
    section: 'Account Deletion',
    subsections: [
      {
        number: '9.1',
        content: 'How to Delete Your Account',
      },
      {
        number: '',
        content: 'To delete your account on the Website, follow these steps:',
        subsections: [
          {
            number: 'a',
            content: 'open the Profile menu',
          },
          {
            number: 'b',
            content: 'select delete account',
          },
          {
            number: 'c',
            content: 'provide the reason for deleting your account and confirm with your PIN',
          },
          {
            number: 'd',
            content:
              'Your data will be deleted 14 (fourteen) calendar days after the account deletion request.',
          },
        ],
      },
      {
        number: '',
        content: '',
      },
      {
        number: '9.2',
        content: 'Data Status',
        subsections: [
          {
            number: 'a',
            content:
              'Your demographic data, such as age, gender, ethnicity, income, education, marital status, occupation, and other demographic data, will be deleted.',
          },
          {
            number: 'b',
            content:
              'Your email address and phone number will be retained to prevent them from being used for re-registration by a different user.',
          },
          {
            number: 'c',
            content:
              'Some transaction and withdrawal data will be retained for 5 (five) years for system records and historical evidence if required by relevant government authorities.',
          },
          {
            number: 'd',
            content:
              'Your survey responses will be retained to support future technical consultations, clarifications, or other inquiries from the parties who hire us to make the survey that You participate in.',
          },
          {
            number: 'e',
            content:
              'You will no longer receive any messages or communications from us once your data has been deleted.',
          },
        ],
      },
    ],
  },
  {
    section: 'Retention Period',
    subsections: [
      {
        number: '',
        content:
          'We will retain your Personal Data for the necessary period to fulfill the purposes set out in this Privacy Policy and in accordance with the applicable laws and regulations in the Republic of Indonesia.',
      },
    ],
  },
  {
    section: 'Our Connection with The EU’s General Data Protection Regulation (GDPR)',
    subsections: [
      {
        number: '',
        content:
          'As long as this Privacy Policy is still valid and we have not stated otherwise, the management of personal data on our Website and Media does not refer to or is subject to the GDPR. Any data that we manage is data of Indonesian residents or citizens, resulting no obligations for us to comply with the GDPR.',
      },
    ],
  },
  {
    section: 'Changes to Our Privacy Policy',
    subsections: [
      {
        number: '',
        content:
          'We will update our Privacy Policy, in line with the development of any relevant laws and regulations, and the development of our business. Any changes we may make to our Privacy Policy in the future will be updated on this page and, if necessary, notified to you by e-mail. Please make sure you review this Privacy Policy from time to time.',
      },
    ],
  },
  {
    section: 'Contact Us',
    subsections: [
      {
        number: '',
        content:
          'If you have any questions and/or comments regarding this Privacy Policy or if you wish to make changes to your Personal Information, please contact us at <a href="mailto:support@populix.co" style="color: blue; text-decoration: underline;">support@populix.co</a> or use the "Contact Us" form at <a href="https://info.populix.co/contact-us" style="color: blue; text-decoration: underline;"  target="_blank">https://info.populix.co/contact-us</a>.',
      },
    ],
  },
]

export default privacyPolicy
